import 'normalize.css';
import { createGlobalStyle } from 'styled-components';

import { colors, sizes } from '@crm-framework/theme';

import './fonts/fonts.css';

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
  }

  html {
    box-sizing: border-box;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: ${sizes.DEFAULT_FONT_SIZE};
    line-height: 1.5;
    color: ${colors.DEFAULT_FONT_COLOR};

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .dashboard-filter-tag__remove {
    margin-left: 10px;
  }

  .dashboard-filter-tag-condition__remove {
    top: 16px;
  }
`;
